import { urlConfig } from "../../config/urlConfig";
import { postCall } from "../httpService";

const UserGet = urlConfig.UserGet;
const GetCountryAndMarket = urlConfig.GetCountryAndMarket;
const SaveUpdateDelete = urlConfig.SaveUpdateDelete;
const CheckDuplicateUser = urlConfig.GetDuplicateUserCheck;
const ResentAPIUserPassword = urlConfig.ResentAPIUserPassword;
const UserActiveStatus = urlConfig.UserActiveStatus;
const DeleteUser = urlConfig.DeleteUser;

export const getUsersData = async (params: any) => {
  try {
    const response = await postCall(UserGet, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getCountryAndMarket = async (params: any) => {
  try {
    const response = await postCall(GetCountryAndMarket, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const saveUsersData = async (params: any) => {
  try {
    const response = await postCall(SaveUpdateDelete, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};
export const checkDuplicateUser = async (params: any) => {
  try {
    const response = await postCall(CheckDuplicateUser, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const resetPassword = async (params: any) => {
  try {
    const response = await postCall(ResentAPIUserPassword, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const userActivityStatus = async (params: any) => {
  try {
    const response = await postCall(UserActiveStatus, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const deleteUser = async (params: any) => {
  try {
    const response = await postCall(DeleteUser, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const nonDfinPasswordResest = async (params: any) => {
  try {
    const response = await postCall(urlConfig.PasswordResetURL, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};